import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";
import IntegerInput from "../../formElements/IntegerInput";

function LoanTypeForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
            <IntegerInput name={'Odhad_Vratenia_Dni'} label={'Odhad Vrátenia - Dni'} value={data.Odhad_Vratenia_Dni} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Typ Zápožičky"
                     labelNew="Pridať Typ Zápožičky"
                     baseUrl='/loan/loans_types/'
                     formContent={formContent}/>
    )
}

export default LoanTypeForm
